import React from 'react';

const Telegram = (props: any) => (
  <span {...props}>
    {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#F6F6F6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.67932 9.675L6.98352 10.535L7.87539 13.4032C7.93245 13.5869 8.15709 13.6548 8.30619 13.5329L9.59059 12.4859C9.72522 12.3762 9.91699 12.3707 10.0577 12.4728L12.3743 14.1547C12.5338 14.2707 12.7598 14.1833 12.7998 13.9905L14.4968 5.8275C14.5405 5.61697 14.3336 5.44133 14.1331 5.51887L4.67662 9.1669C4.44325 9.2569 4.44528 9.5873 4.67932 9.675ZM7.73011 10.0776L12.2334 7.30407C12.3143 7.25437 12.3976 7.3638 12.3281 7.42827L8.61158 10.8829C8.48095 11.0045 8.39668 11.1673 8.37282 11.3439L8.24622 12.2821C8.22945 12.4074 8.05348 12.4198 8.01892 12.2986L7.53201 10.5877C7.47625 10.3926 7.55751 10.1842 7.73011 10.0776Z"
        fill="#0D0D0E"
      />
    </svg> */}
    <svg width={20} height={20} viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" fill="#000" />
      <path
        d="M4.5 9.6L6.9 10.5L7.8 13.4C7.9 13.6 8.1 13.7 8.3 13.5L9.6 12.5C9.7 12.4 9.9 12.4 10 12.5L12.4 14.2C12.5 14.3 12.8 14.2 12.8 14L14.5 5.8C14.5 5.6 14.3 5.4 14.1 5.5L4.7 9.2C4.4 9.3 4.4 9.6 4.5 9.6ZM7.7 10.1L12.2 7.3C12.3 7.2 12.4 7.4 12.3 7.4L8.6 10.9C8.5 11 8.4 11.2 8.4 11.3L8.2 12.3C8.2 12.4 8.1 12.4 8 12.3L7.5 10.6C7.5 10.4 7.6 10.2 7.7 10.1Z"
        fill="#fff"
      />
    </svg>
  </span>
);

export default Telegram;
